/**
 * Simple native checkbox — no MUI dependency.
 * @param {{ checked, onChange }} props
 */
export default function IntFigCheckbox({ checked, onChange }) {
  return (
    <label className="ct__intfig-checkbox">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
    </label>
  );
}
